import React from 'react';
import { Container, Typography, Grid, Paper, Box } from '@mui/material';
import Header from '../Components/header/Header'; // 引入 Header 组件
import Footer from '../Components/footer/Footer'; // 引入 Footer 组件

const ContactUs = () => {
  return (
    <div
      style={{
        overflowX: 'hidden',
        position: 'relative',
        minHeight: '100vh',
        backgroundColor: '#ffffff',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      {/* Header 部分 */}
      <Box sx={{ paddingBottom: { xs: '16px', md: '0' } }}>
        <Header />
      </Box>

      {/* 主体内容 */}
      <Container
        maxWidth="lg"
        sx={{
          flex: 1,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          padding: { xs: '24px 16px', md: '50px 0' }, // 上下内边距在移动端和桌面端不同
        }}
      >
        <Grid container spacing={6} alignItems="stretch">
          {/* 左侧：公司信息展示 */}
          <Grid item xs={12} md={6}>
            <Paper
              elevation={3}
              sx={{
                padding: '30px',
                borderRadius: '16px',
                backgroundColor: '#f7f7f7',
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
              }}
            >
              <Typography variant="h5" sx={{ fontWeight: 'bold', marginBottom: '16px' }}>
                Company Information
              </Typography>
              <Box sx={{ marginBottom: '12px' }}>
                <Typography variant="body1">
                  <strong>Name:</strong> Spring Creek
                </Typography>
              </Box>
              <Box sx={{ marginBottom: '12px' }}>
                <Typography variant="body1">
                  <strong>Contact Person:</strong> Nan Wu (Factory Coordinator)
                </Typography>
              </Box>
              <Box sx={{ marginBottom: '12px' }}>
                <Typography variant="body1">
                  <strong>Phone:</strong> 132-9536-8835
                </Typography>
              </Box>
              <Box sx={{ marginBottom: '12px' }}>
                <Typography variant="body1">
                  <strong>Address:</strong> 1/3 VILLAGE NO. 6, NONG YAI SUBDISTRICT,
                  <br />
                  NONG YAI DISTRICT, CHONBURI PROVINCE 20190
                </Typography>
              </Box>
            </Paper>
          </Grid>

          {/* 右侧：Google Maps 地图 */}
          <Grid item xs={12} md={6}>
            <Paper
              elevation={3}
              sx={{
                borderRadius: '16px',
                overflow: 'hidden',
                height: '100%', // 确保填满容器
              }}
            >
              <iframe
                title="Google Map"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3874.052862212473!2d101.00145467667352!3d13.117803894387382!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x310305f9b80cbbab%3A0x6f2d7e6d97a2e6e3!2sNong%20Yai%2C%20Nong%20Yai%20District%2C%20Chon%20Buri%2020190%2C%20Thailand!5e0!3m2!1sen!2sus!4v1697531922918!5m2!1sen!2sus"
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              ></iframe>
            </Paper>
          </Grid>
        </Grid>
      </Container>

      {/* Footer 部分 */}
      <Box sx={{ marginTop: 'auto', paddingTop: { xs: '16px', md: '0' } }}>
        <Footer />
      </Box>
    </div>
  );
};

export default ContactUs;